/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_ContinueInputs */



/**
* | output |
* | --- |
* | "Next" |
*
* @param {Onboarding_Value_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_continue = /** @type {((inputs?: Onboarding_Value_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suivant")
	return /** @type {LocalizedString} */ ("Next")
});